import React from "react";

export const PageHeader = ({
  children,
  title,
  className,
}: {
  children?: React.ReactNode;
  title: string;
  className?: string;
}) => {
  return (
    <div className="border-b border-gray-200 pb-4 flex items-center justify-between sticky top-0">
      <h3 className={`text-lg font-semibold text-gray-900 ${className}`}>
        {title}
      </h3>
      <section>{children}</section>
    </div>
  );
};
